import React from 'react';
import _ from 'lodash';
import { Flex } from 'antd';
import { WidgetStatistic } from 'src/pages/dashboard/styles';
import {
	CardTitle,
	CardData,
	IconArea
} from 'src/pages/dashboard/components/cards/styles';
import antdIconsMap from 'src/common/mapping/antdIconsMap';
import IconAsText from 'src/components/IconAsText';

export interface IRenderedIconIndicatorProps {
	description?: string;
	title?: string;
	value?: string | number;
	icon?: keyof typeof antdIconsMap;
}

export default function RenderedIconIndicator({
	description,
	icon,
	value,
	title,
}: IRenderedIconIndicatorProps) {
	return (
		<Flex
			gap={16}
			align='center'
			justify='space-between'
			style={{ width: '100%', height: '100%', padding: '12px', }}
		>
			<Flex vertical gap={4}>
				<CardTitle>{description}</CardTitle>
				<CardData>
					<span>{title}</span>
					<WidgetStatistic>{value}</WidgetStatistic>
				</CardData>
			</Flex>
			<IconArea
				style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				{icon && (
					<IconAsText color={'white'} fontSize={22} icon={icon} />
				)}
			</IconArea>
		</Flex>
	);
}
